import numbro from "numbro";

export const DEFAULT_EMPTY_VALUE = "-";
const IRM_API_DATE_UNDEFINED_RESPONSE = "0001-01-01T00:00:00Z";
const IRM_API_NUMBER_UNDEFINED_RESPONSE = -4;

const isValidValue = (value: any) =>
  ![
    undefined,
    null,
    IRM_API_DATE_UNDEFINED_RESPONSE,
    `${IRM_API_NUMBER_UNDEFINED_RESPONSE}`,
    "",
    IRM_API_NUMBER_UNDEFINED_RESPONSE,
  ].includes(value);

// Use the value OR, if invalid, the default "-"
export const valueOr = <T>(
  value: T | undefined | null | string | number
): NonNullable<T> | typeof DEFAULT_EMPTY_VALUE =>
  isValidValue(value) ? (value as NonNullable<T>) : DEFAULT_EMPTY_VALUE;

export const valueToDate = (value?: string) =>
  value && value !== IRM_API_DATE_UNDEFINED_RESPONSE
    ? new Date(value)
    : undefined;

export const formatDate = (
  value: Date | typeof DEFAULT_EMPTY_VALUE
): string => {
  if (value instanceof Date) {
    return `${value.getUTCDate()} ${value.toLocaleDateString("en-us", {
      month: "short",
      year: "numeric",
      timeZone: "UTC", // Dates have UTC timezone, but the timezone must be ignored when formatting dates.
    })}`; // DD mm YYYY (13 Jun 2020)
  }
  return value;
};

export const formatNumber = (value: number | string, precision = 2): string =>
  numbro(value).format({
    thousandSeparated: true,
    mantissa: precision,
    negative: "parenthesis",
  });

export const formatCurrency = (
  value: number | string,
  symbol: string
): string =>
  numbro(value).formatCurrency({
    thousandSeparated: true,
    mantissa: 2,
    currencySymbol: symbol,
  });

export const formatUngroupedNumber = (value: number | string): string =>
  numbro(value).format({
    thousandSeparated: false,
    mantissa: 2,
  });

export const formatQuantityValue = (value?: number) =>
  isValidValue(value) ? formatNumber(value as number) : DEFAULT_EMPTY_VALUE;
